import { FeatureFlag, useFeatureGate } from "features/Statsig";
import useClerkMetadata from "features/User/hooks/useClerkMetadata";

export const useTableViewNewTag = () => {
  const tableViewFeatureFlag = useFeatureGate(
    FeatureFlag.RESULTS_TABLE_VIEW
  ).value;
  const { userMetadata, updateUserMetadata, isUserMetadataLoaded } =
    useClerkMetadata();

  const dismissTableViewNewTag = () => {
    updateUserMetadata({
      is_table_view_new_tag_hidden: true,
    });
  };

  return {
    isTableViewNewTagHidden:
      !tableViewFeatureFlag ||
      !isUserMetadataLoaded ||
      userMetadata?.is_table_view_new_tag_hidden === true,
    dismissTableViewNewTag,
  };
};
